// extracted by mini-css-extract-plugin
module.exports = {"base":"UPlotChart_base__tNZn3","dark":"UPlotChart_dark__2mUq5"};